import { useQuery } from "react-query";

import { agencyQueryKeys } from "./queryKeys";
import useQSBuilder from "../../hooks/useQSBuilder";
import useApiHelper from "../../services/useApiHelper";
import { IDefaultResponseWithData } from "../../models/system/DefaultResponse";
import { IContactUsForm } from "../../models/agency/ContactUsForm";

export function useAgencyEnquiresByPerson(agencyId: string, personId: string) {
  const { get } = useApiHelper();
  const buildQs = useQSBuilder();

  const enquiries = useQuery({
    queryKey: agencyQueryKeys.enquiriesByPerson(agencyId, personId),
    queryFn: () =>
      get(
        `/agency/${agencyId}/enquiries${buildQs({ personId })}`
      ) as unknown as IDefaultResponseWithData<IContactUsForm[]>,
    refetchOnWindowFocus: false,
  });

  return {
    enquiries,
  };
}
